import { List } from "immutable";

import { OUTLINE_LABEL_COLUMN_MIN_WIDTH, OUTLINE_MULTI_LINE_TEXT_COLUMN_MIN_WIDTH } from "../constants";
import outlineColumnIds, { fixedAndStickyColumnIds } from "../constants/outlineColumnIds";
import { PropertyFormatIdentifier } from "../constants/propertyFormats";
import tableCellTypes from "../constants/tableCellTypes";
import { propertySelectors } from "../modules/definition/properties";
import { immutableRecords } from "../types";

const tableCellTypeForProperty = property => {
  switch (property.format) {
    case PropertyFormatIdentifier.text:
      return tableCellTypes.text;
    case PropertyFormatIdentifier.multitext:
      return tableCellTypes.multitext;
    case PropertyFormatIdentifier.integer:
      return tableCellTypes.integer;
    case PropertyFormatIdentifier.double:
    case PropertyFormatIdentifier.currency:
    case PropertyFormatIdentifier.percentage:
      return tableCellTypes.number;
    case PropertyFormatIdentifier.boolean:
      return tableCellTypes.checkbox;
    case PropertyFormatIdentifier.list:
      return property.multiple ? tableCellTypes.list : tableCellTypes.dropdown;
  }
};

const isColumnMultiLineType = (id, propertiesById) => {
  return (
    id &&
    propertiesById &&
    propertiesById.get(id) &&
    tableCellTypeForProperty(propertiesById.get(id)) === tableCellTypes.multitext
  );
};

const getColumnLimitedWidth = (id, width, propertiesById) => {
  let result = width;
  if (id === outlineColumnIds.label) {
    result = Math.max(OUTLINE_LABEL_COLUMN_MIN_WIDTH, width);
  } else if (id === outlineColumnIds.summary || isColumnMultiLineType(id, propertiesById)) {
    result = Math.max(OUTLINE_MULTI_LINE_TEXT_COLUMN_MIN_WIDTH, width);
  }
  return result;
};

const fixColumnsOrderByFixedAndSticky = colList => {
  // Put the fixed and sticky columns at head end
  const fixedColumns = fixedAndStickyColumnIds.reduce((fixedList, cId) => {
    const foundCol = colList.find(c => c.id === cId);
    return foundCol ? fixedList.push(foundCol) : fixedList;
  }, List([]));
  const normalColumns = colList.filter(c => !fixedAndStickyColumnIds.includes(c.id));
  return fixedColumns.concat(normalColumns);
};

const updateTableColumnList = (list, id, showColumn, width, globalState) => {
  if (showColumn) {
    const propertiesById = propertySelectors.getPropertiesById(globalState);
    const limitedWidth = getColumnLimitedWidth(id, width, propertiesById);
    const index = list.findIndex(c => c.id === id);
    if (index >= 0) {
      return list.setIn([index, "width"], limitedWidth);
    } else {
      const newList = list.push(
        immutableRecords.TableViewColumnRecord({
          id,
          width: limitedWidth
        })
      );
      return fixColumnsOrderByFixedAndSticky(newList);
    }
  } else {
    return list.filter(c => c.id !== id);
  }
};

const moveTableColumnInList = (list, id, index) => {
  const col = list.find(c => c.id === id);
  return fixColumnsOrderByFixedAndSticky(list.filter(c => c.id !== id).splice(index, 0, col));
};

export { getColumnLimitedWidth, moveTableColumnInList, tableCellTypeForProperty, updateTableColumnList };
